import { MIME_TYPE_GROUPS } from '../mime-type-groups';

export const ACCEPTED_DATA_TYPES = MIME_TYPE_GROUPS.DATA.map((mimeType) => mimeType.replace('text/', ''));
export const ACCEPTED_DATA_TYPES_STRING = ACCEPTED_DATA_TYPES.join(', ').toUpperCase();
